import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { CloseOutlined } from '@ant-design/icons';
import { Radio, Button } from 'antd';

import modal from '~components/modal';
import useSwitchRole from '../useSwitchRole';

const SwitchRoleModal = ({ onClose }) => {
  const { t } = useTranslation();

  const { loading, userRoles, authRole, currentRole, setCurrentRole, handleConfirmSwitchRole } =
    useSwitchRole({
      onClose,
    });

  if (!userRoles?.length) {
    return null;
  }

  return (
    <div className="switch-role-modal">
      <div className="switch-role-modal__container">
        <div className="switch-role-modal__position-container">
          <div className="switch-role-modal__header-container">
            <h3 className="switch-role-modal__title">
              {t('cms.switch_role_modal.title.switch_role')}
            </h3>
            <button
              className="switch-role-modal__btn switch-role-modal__btn--close"
              onClick={onClose}
            >
              <CloseOutlined style={{ fontSize: '12px', color: '#9e9e9e' }} />
            </button>
          </div>
          <div className="switch-role-modal__content-container">
            <div className="switch-role-modal__role-list">
              <Radio.Group name="radiogroup" onChange={e => setCurrentRole(e.target.value)}>
                <For each="role" index="index" of={userRoles}>
                  <Radio
                    key={index}
                    value={role.slug}
                    style={{
                      display: 'block',
                      height: '48px',
                      lineHeight: '48px',
                      backgroundColor: '#f8f8f6',
                    }}
                    disabled={role.slug === authRole}
                  >
                    {role.name ? role.name : t(`cms.switch_role_modal.role.${role.slug}`)}
                  </Radio>
                </For>
              </Radio.Group>
            </div>
          </div>
          <div className="switch-role-modal__footer-container">
            <Button
              size="large"
              type="primary"
              loading={loading}
              className="switch-role-modal__btn switch-role-modal__btn--confirm"
              disabled={currentRole === null}
              onClick={handleConfirmSwitchRole}
            >
              {t('cms.switch_role_modal.btn.confirm')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

SwitchRoleModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default modal()(SwitchRoleModal);
